/**
 * Enregistre le protocole `pmtiles://` dans MapLibre (une seule fois au démarrage).
 * Requis pour les styles auto-hébergés servis par le proxy Django (pmtiles-flat-light, etc.).
 */
import * as pmtiles from 'pmtiles'
import maplibregl from 'maplibre-gl'

let registered = false

export function registerPmtilesProtocol(): void {
  if (registered) return
  const protocol = new pmtiles.Protocol()
  maplibregl.addProtocol('pmtiles', protocol.tile.bind(protocol))
  registered = true
}

registerPmtilesProtocol()
